import { render, staticRenderFns } from "./ScreeningCompleted.vue?vue&type=template&id=d01b4bc4"
import script from "./ScreeningCompleted.vue?vue&type=script&lang=js"
export * from "./ScreeningCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports